<template>
  <div
    class="comment_icons"
    v-if="activityType == 6 || activityType == 5 || activityType == 8"
  >
    <span class="iconfont">&#xe604;</span>
    <span class="num">{{ joinsnum }}</span>
  </div>
  <div class="comment_icons" v-else>
    <span v-show="ShowComment" @click="workGood(workId, activityId)" class="iconfont">&#xe603;</span>
    <span v-show="ShowComment" class="num">{{ goodsnum }}</span>
    <span v-show="ShowComment" class="iconfont">&#xe60d;</span>
    <span v-show="ShowComment" class="num">{{ commentnum }}</span>
    <span class="iconfont">&#xe7d0;</span>
    <span class="num">{{ looknum }}</span>
  </div>
</template>
<script>
export default {
  name: "IndexIcons",
  props: [
    "goodsnum",
    "commentnum",
    "looknum",
    "activityId",
    "workId",
    "joinsnum",
    "activityType",
    "ShowComment"
  ],
  data() {
    return {};
  },
  computed: {
    isShow() {
      return sessionStorage.getItem("activity_id") == 426 ? false : true;
    }
  },
  methods: {
    // 作品点赞
    workGood(workId, activityId) {
      console.log(workId, activityId, this.goodsnum);
      var params = {
        activity_id: activityId,
        activity_works_id: workId
      };
      this.$api
        .workMark(params)
        .then(res => {
          if (res.code == 200) {
            this.$emit("clickMark");
            this.$message({
              message: res.message,
              type: "success"
            });
          } else {
            this.$message(res.message);
          }
        })
        .catch(err => console.log(err));
    }
  }
};
</script>
<style scoped>
.comment_icons {
  margin: 14px 0px;
}
.comment_icons .iconfont {
  margin-right: 5px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  vertical-align: middle;
  cursor: pointer;
}
.comment_icons .num {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-right: 22px;
}
@media (min-width: 1024px) {
  .comment_icons .num {
    margin-right: 1px;
  }
} /*>=1024的设备*/

@media (min-width: 1100px) {
} /*>=1100的设备*/
@media (min-width: 1280px) {
  .comment_icons .num {
    margin-right: 15px;
  }
} /*>=1280的设备*/
</style>



// WEBPACK FOOTER //
// src/components/Icons.vue